import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { BillingSettings } from "@/components/settings/billing-settings";
import { creditsQuery } from "@/lib/loaders";

/**
 * The loader resolves the plan before render so the Current Plan card shows the
 * correct tier on first paint instead of flashing "Free" / "$0". Polar-specific
 * details (invoices, exact charge) still stream in with their own skeletons.
 */
export const Route = createFileRoute("/_workspace/settings/billing")({
  loader: ({ context }) => context.queryClient.ensureQueryData(creditsQuery),
  component: SettingsBillingPage,
});

function SettingsBillingPage() {
  const { data: initialCredits } = useQuery(creditsQuery);
  return <BillingSettings initialCredits={initialCredits ?? null} />;
}
